import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { GmailReplyData } from '@models/models';

@Component({
	selector: 'email-reply-modal',
	template: require('./email-reply-modal.component.html'),
	styles: [require('./email-reply-modal.component.scss')]
})
export class EmailReplyModalComponent {
	@Input() emailData: GmailReplyData;
	@Input() isEdit: boolean;
	@Input() disableBtn: boolean;
	@Output() onSaveSettings = new EventEmitter();

	constructor(private messageService: MessageService) {}

	saveEmailReplyForm(event) {
		if (this.emailData.senderName) {
			if (
				!this.emailData.senderEmail ||
				(this.emailData &&
					this.emailData.senderEmail &&
					this.isIncorrectMail(this.emailData.senderEmail))
			) {
				this.messageService.showToaster('e_1', 'general');
				return;
			}

			if (this.emailData.senderEmail) {
				this.onSaveSettings.emit({ isEdit: this.isEdit, data: this.emailData });
			}
		} else {
			this.onSaveSettings.emit({ isEdit: this.isEdit, data: this.emailData });
		}
	}

	copyToClipboard(ev): void {
		ev.preventDefault();
		this.messageService.showToaster('i_1', 'emailSettings');
	}

	private isIncorrectMail(email) {
		const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return !emailRegex.test(email);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/settings/email-reply-modal/email-reply-modal.component.ts